import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  NLPServiceSentiment,
  NLPServicesText,
  NLPServicesFraud,
  NLPServicesChatbots,
  NLPServicesApp,
  NLPServicesConsulting,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: NLPServiceSentiment,
    title: "Sentiment Analysis",
    description:
      "Understand customer emotions and intentions with precise Sentiment Analysis. Our custom-trained NLP models help you make data-driven decisions to improve customer satisfaction by interpreting feedback and detecting trends in sentiment.",
  },
  {
    icon: NLPServicesText,
    title: "Text Analytics",
    description:
      "Extract actionable insights from unstructured data with advanced Text Analytics. Automate document processing, emails, and conversations to classify and analyze information, driving smarter decision-making and business growth.",
  },
  {
    icon: NLPServicesFraud,
    title: "Fraud Detection",
    description:
      "Enhance your fraud prevention with sophisticated monitoring and analysis tools. Our NLP services identify fraudulent claims more accurately, reducing losses and boosting operational efficiency and customer satisfaction.",
  },
  {
    icon: NLPServicesChatbots,
    title: "Chatbots",
    description:
      "Optimize communication with enterprise-grade chatbots. Our solutions provide 24/7 assistance, automating interactions to enhance customer engagement and employee productivity, ensuring seamless support operations.",
  },
  {
    icon: NLPServicesApp,
    title: "NLP Application Development",
    description:
      "Develop custom NLP applications tailored to your needs, from language translation to content summarization. Our team delivers solutions that enhance business efficiency and drive growth through innovative NLP technologies.",
  },
  {
    icon: NLPServicesConsulting,
    title: "NLP Consulting",
    description:
      "Leverage the expertise of TekRevol’s NLP consultants to harness the full potential of language processing. We guide you on best practices, implementation strategies, and how to maximize NLP's impact on your business.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section nlp_impro_services p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Natural Language Processing Services <span>We Offer</span>
            </h2>
            <p className="impro_para">
              Leverage advanced Natural Language Processing (NLP) solutions to
              transform how you interact with text. Whether you need text
              processing, translation, enhanced search capabilities, or
              AI-driven customer service chatbots, our NLP development services
              have you covered with expertise across several industries.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={10} className="m-auto">
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Consult NLP Solutions
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
